/**
 * Thingiverse API Integration for 3D Printing Calculator
 * Uses direct API calls with OAuth 2.0 authentication
 * Supports both popular models and search functionality
 * Modified to support unlimited pagination with Next button navigation
 * Items per page increased to 12
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Thingiverse Direct API integration loaded with unlimited pagination');
  
  // Constants
  const ITEMS_PER_PAGE = 16; // Changed from 8 to 15 items per page
  const ACCESS_TOKEN = "f712284f405040c7f34f47c8593e2dae"; // Replace with your actual token
  
  // State variables
  let currentModels = []; // Models for current page only
  let currentPage = 1;
  let currentSearchTerm = '';
  let isLoading = false;
  let lastSearchTerm = ''; // Track the last search term we used for the API
  
  // Function to load a specific page of models from Thingiverse API
  function loadModelPage(page = 1) {
  if (isLoading) {
    console.log('Already loading models, skipping');
    return;
  }
  
  const modelGrid = document.getElementById('modelGrid');
  if (!modelGrid) {
    console.error('modelGrid element not found');
    return;
  }
  
  console.log('Loading page:', page);
  isLoading = true;
  currentPage = page;
  
  // Show loading state
  modelGrid.innerHTML = `
    <div style="grid-column: 1/-1; text-align: center; padding: 40px;">
      <div style="display: inline-block; width: 40px; height: 40px; border: 3px solid rgba(0,0,0,0.1); border-radius: 50%; border-top-color: #3498db; animation: spin 1s linear infinite;"></div>
      <div style="margin-top: 15px; font-size: 14px;">Loading popular models from the last 7 days...</div>
    </div>
  `;
  
  // Determine which API endpoint to use based on search term
  let apiUrl = '';
  
  // If we have a search term, use the search endpoint with sort=popular
  if (currentSearchTerm && currentSearchTerm.trim() !== '') {
    // Update lastSearchTerm to track what we searched for
    lastSearchTerm = currentSearchTerm.trim();
    const encodedTerm = encodeURIComponent(lastSearchTerm);
    
    // Using the format from the example with search term
    apiUrl = `https://api.thingiverse.com/search/${encodedTerm}/?type=things&page=${page}&per_page=${ITEMS_PER_PAGE}&sort=relevant&show_customized=show_customized`;
    console.log(`Searching Thingiverse for: "${lastSearchTerm}" sorted by popularity (Page ${page}, ${ITEMS_PER_PAGE} items per page)`);
  } else {
    // If no search term, use the popular endpoint with a general query
    lastSearchTerm = '';
    
    // Using the format from example but with a general query to show popular items
    // We're using 'things' as the general search query to get all types of models
    apiUrl = `https://api.thingiverse.com/search/?type=things&page=${page}&per_page=${ITEMS_PER_PAGE}&sort=popular&posted_after=now-30d`;
    console.log(`Loading popular models sorted by popularity (Page ${page}, ${ITEMS_PER_PAGE} items per page)`);
  }
  
  // Make a direct API call to Thingiverse with OAuth 2.0 authentication
  fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${ACCESS_TOKEN}`,
      'Accept': 'application/json',
      'Host': 'api.thingiverse.com'
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    console.log('Thingiverse API response:', data);
    
    // Based on the sample response format, the results will be in data.hits
    const modelData = data.hits;
    
    if (modelData && Array.isArray(modelData)) {
      // Check if we have any results
      const hasResults = modelData.length > 0;
      
      if (hasResults) {
        // Transform the API data into our expected format
        currentModels = transformThingiverseData(modelData);
        
        // Ensure we only show exactly ITEMS_PER_PAGE items per page
        if (currentModels.length > ITEMS_PER_PAGE) {
          currentModels = currentModels.slice(0, ITEMS_PER_PAGE);
        }
        
        // Display the current page of models
        displayModels();
        // Always enable next button regardless of results
        updatePaginationControls(true);
        
        console.log(`Loaded page ${page} with ${currentModels.length} models`);
      } else {
        console.log('No models available on this page');
        
        if (page === 1) {
          // If first page has no results, show sample models
          currentModels = getSampleModels();
          displayModels();
          updatePaginationControls(false); // No more pages after samples
        } else {
          // If not the first page, show end of results message
          modelGrid.innerHTML = `
            <div style="grid-column: 1/-1; text-align: center; padding: 40px;">
              <p style="font-size: 16px; color: #636e72;">You've reached the end of available models</p>
              <button id="backToStartBtn" style="padding: 10px 20px; background: linear-gradient(135deg, #0984e3, #2980b9); color: white; border: none; border-radius: 25px; margin-top: 15px; cursor: pointer; font-weight: 500;">Back to First Page</button>
            </div>
          `;
          
          // Add event listener to back button
          const backBtn = document.getElementById('backToStartBtn');
          if (backBtn) {
            backBtn.addEventListener('click', function() {
              loadModelPage(1);
            });
          }
          
          updatePaginationControls(false); // No more pages
        }
      }
    } else {
      // Fall back to sample models if we didn't get valid data
      console.warn('Invalid API response, using sample models');
      currentModels = getSampleModels();
      displayModels();
      updatePaginationControls(false); // No more pages after samples
    }
  })
  .catch(error => {
    console.error('Error loading models:', error);
    console.log('Falling back to sample models due to API error');
    
    // Fall back to sample models in case of error
    currentModels = getSampleModels();
    displayModels();
    updatePaginationControls(false); // No more pages after samples
    
    // Show feedback to the user
    const modelGrid = document.getElementById('modelGrid');
    if (modelGrid) {
      const warningBanner = document.createElement('div');
      warningBanner.style.gridColumn = '1/-1';
      warningBanner.style.marginBottom = '20px';
      warningBanner.style.padding = '10px 15px';
      warningBanner.style.background = '#fff3cd';
      warningBanner.style.border = '1px solid #ffeeba';
      warningBanner.style.borderRadius = '4px';
      warningBanner.style.color = '#856404';
      warningBanner.innerHTML = `
        <p style="margin: 0; font-size: 14px;">
          <strong>Note:</strong> Showing sample models because we couldn't connect to Thingiverse.
          ${error.message}
        </p>
      `;
      modelGrid.insertBefore(warningBanner, modelGrid.firstChild);
    }
  })
  .finally(() => {
    isLoading = false;
  });
}
  
  // Transform Thingiverse API data to our expected format
  function transformThingiverseData(data) {
    if (!data || !Array.isArray(data)) {
      console.warn('Invalid data format from Thingiverse API');
      return getSampleModels();
    }
    
    return data.map(item => {
      // For search results, the actual model data is in the 'model' property
      const model = item.model || item;
      
      // Extract dimensions if available
      let dimensions = '100 x 100 x 100 mm';
      if (model.default_part && model.default_part.dimensions) {
        const dim = model.default_part.dimensions;
        dimensions = `${dim.x} x ${dim.y} x ${dim.z} mm`;
      }
      
      // Extract image URL with priority on higher quality images
      const imageUrl = model.images && model.images.length > 0 ? 
                     (model.images[0].sizes && model.images[0].sizes.medium ? 
                      model.images[0].sizes.medium.url : 
                      (model.images[0].url || '')) : 
                     (model.preview_image || model.thumbnail || '');
      
      // Retain all original properties plus our derived ones
      return {
        // Original data from API
        ...model,
        // Our standardized properties
        id: model.id.toString(),
        name: model.name || 'Unnamed Model',
        description: model.description || 'No description available',
        dimensions: dimensions,
        printTime: estimatePrintTime(),
        imageUrl: imageUrl,
        source: 'Thingiverse',
        modelUrl: model.public_url || model.url || '#',
        creator: model.creator ? model.creator.name : 'Unknown',
        // Extract tags if available
        tags: model.tags || []
      };
    });
  }
  
  // Estimate print time with a base standard time
  function estimatePrintTime() {
    // Base time with small random variation for a more natural feel
    const baseTime = 3;
    const variation = Math.random() * 0.5 - 0.25;
    const finalTime = baseTime + variation;
    
    return `~${finalTime.toFixed(1)} hours`;
  }
  
  // Get sample models for fallback
  function getSampleModels() {
    return [
      {
        id: 'sample1',
        name: 'Geometric Vase',
        description: 'A modern geometric vase with an intricate honeycomb pattern.',
        dimensions: '100 x 100 x 120 mm',
        printTime: '~2.5 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample2',
        name: 'Phone Stand',
        description: 'Adjustable phone stand that works with most smartphones.',
        dimensions: '80 x 100 x 70 mm',
        printTime: '~1.8 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample3',
        name: 'Desk Organizer',
        description: 'Keep your desk tidy with this practical organizer.',
        dimensions: '120 x 80 x 50 mm',
        printTime: '~3.2 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample4',
        name: 'Cable Clip',
        description: 'Simple but effective cable management solution.',
        dimensions: '30 x 15 x 10 mm',
        printTime: '~0.5 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample5',
        name: 'Succulent Planter',
        description: 'Modern planter perfect for small succulents and cacti.',
        dimensions: '70 x 70 x 60 mm',
        printTime: '~2.0 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample6',
        name: 'Headphone Stand',
        description: 'Elegant stand to display and organize your headphones.',
        dimensions: '100 x 200 x 80 mm',
        printTime: '~4.5 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample7',
        name: 'Wall Hook',
        description: 'Simple but sturdy hook for hanging items on your wall.',
        dimensions: '40 x 60 x 15 mm',
        printTime: '~1.2 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample8',
        name: 'SD Card Holder',
        description: 'Compact organizer for your SD and microSD cards.',
        dimensions: '90 x 50 x 15 mm',
        printTime: '~1.5 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample9',
        name: 'Smartphone Amplifier',
        description: 'Passive amplifier that boosts your phone speaker without electricity.',
        dimensions: '120 x 80 x 100 mm',
        printTime: '~3.8 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample10',
        name: 'Fidget Cube',
        description: 'Multi-sided fidget toy with different interactive features.',
        dimensions: '40 x 40 x 40 mm',
        printTime: '~2.2 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample11',
        name: 'Low Poly Skull',
        description: 'Decorative skull with modern low-polygon aesthetic.',
        dimensions: '80 x 100 x 80 mm',
        printTime: '~3.0 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample12',
        name: 'Floating Shelf Bracket',
        description: 'Hidden bracket for creating floating shelf effect.',
        dimensions: '100 x 40 x 30 mm',
        printTime: '~2.4 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample13',
        name: 'Modular Drawer Organizer',
        description: 'Customizable drawer dividers for organizing small items.',
        dimensions: '120 x 80 x 40 mm',
        printTime: '~2.8 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample14',
        name: 'Business Card Holder',
        description: 'Elegant desktop card holder for professional settings.',
        dimensions: '90 x 55 x 40 mm',
        printTime: '~1.7 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      },
      {
        id: 'sample15',
        name: 'Key Hanger',
        description: 'Wall-mounted key organizer with modern design.',
        dimensions: '150 x 50 x 20 mm',
        printTime: '~2.2 hours',
        imageUrl: 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg',
        source: 'Sample Library',
        modelUrl: '#',
        creator: 'Sample'
      }
    ];
  }
  
  // Initialize the integration
  function initialize() {
    console.log('Initializing Thingiverse Direct API integration with unlimited pagination');
    
    // Update the model library section title
    const libraryTitle = document.querySelector('.source-tab[data-source="library"]');
    if (libraryTitle) {
      libraryTitle.textContent = 'Select from Thingiverse';
    }
    
    // Add Thingiverse branding if desired
    addThingiverseBranding();
    
    // Set up event listeners for tabs, search, filtering, etc.
    setupEventListeners();
    
    // Check if we're already on the library tab
    const libraryTab = document.querySelector('.source-tab[data-source="library"]');
    const isLibraryTabActive = libraryTab && libraryTab.classList.contains('active');
    
    if (isLibraryTabActive) {
      // If we're already on the library tab, load models immediately
      loadModelPage(1);
    }
  }
  
  // Add Thingiverse branding
  function addThingiverseBranding() {
    const libraryContainer = document.querySelector('.library-container');
    if (libraryContainer && !document.getElementById('thingiverse-branding')) {
      // Create branding element
      const branding = document.createElement('div');
      branding.id = 'thingiverse-branding';
      branding.style.textAlign = 'center';
      branding.style.marginBottom = '15px';
      branding.innerHTML = `
        <div style="font-size: 12px; color: #666; margin-bottom: 5px;">Models provided by</div>
        <div style="font-weight: bold; color: #2196F3; font-size: 16px;">Thingiverse</div>
      `;
      
      // Insert at the top of the library container
      if (libraryContainer.firstChild) {
        libraryContainer.insertBefore(branding, libraryContainer.firstChild);
      } else {
        libraryContainer.appendChild(branding);
      }
    }
  }
  
  // Set up all required event listeners
  function setupEventListeners() {
    // Search input
    const searchInput = document.getElementById('modelSearchInput');
    if (searchInput) {
      // Use a debounce function to avoid making too many API calls
      let searchTimeout;
      
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimeout);
        
        // Update the currentSearchTerm immediately for UI updates
        currentSearchTerm = this.value.toLowerCase().trim();
        
        // Show a loading indicator
        const modelGrid = document.getElementById('modelGrid');
        if (modelGrid) {
          modelGrid.innerHTML = `
            <div style="grid-column: 1/-1; text-align: center; padding: 40px;">
              <div>Typing to search...</div>
            </div>
          `;
        }
        
        // Wait a short delay before triggering the actual search
        searchTimeout = setTimeout(function() {
          // Reset to page 1 for a new search
          loadModelPage(1);
        }, 500); // 500ms delay
      });
      
      // Add event listener for the Enter key to trigger immediate search
      searchInput.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
          clearTimeout(searchTimeout);
          currentSearchTerm = this.value.toLowerCase().trim();
          loadModelPage(1);
        }
      });
    }
    
    // Pagination buttons - remove any existing event listeners first
    const paginationPrev = document.querySelector('.pagination-prev');
    const paginationNext = document.querySelector('.pagination-next');
    
    // Remove old event listeners if they exist by cloning and replacing
    if (paginationPrev) {
      const newPrev = paginationPrev.cloneNode(true);
      paginationPrev.parentNode.replaceChild(newPrev, paginationPrev);
      
      // Add new event listener
      newPrev.addEventListener('click', function() {
        console.log('Previous button clicked. Current page:', currentPage);
        if (currentPage > 1 && !isLoading) {
          loadModelPage(currentPage - 1);
          
          // Scroll to top of grid
          const modelGrid = document.getElementById('modelGrid');
          if (modelGrid) {
            modelGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    }
    
    if (paginationNext) {
      const newNext = paginationNext.cloneNode(true);
      paginationNext.parentNode.replaceChild(newNext, paginationNext);
      
      // Add new event listener
      newNext.addEventListener('click', function() {
        console.log('Next button clicked. Current page:', currentPage);
        if (!isLoading) {
          loadModelPage(currentPage + 1);
          
          // Scroll to top of grid
          const modelGrid = document.getElementById('modelGrid');
          if (modelGrid) {
            modelGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    }
    
    // Tab switching
    const sourceTabs = document.querySelectorAll('.source-tab');
    if (sourceTabs.length > 0) {
      sourceTabs.forEach(tab => {
        const source = tab.getAttribute('data-source');
        
        tab.addEventListener('click', function(event) {
          event.preventDefault();
          
          // Remove active class from all tabs
          sourceTabs.forEach(t => t.classList.remove('active'));
          
          // Add active class to this tab
          this.classList.add('active');
          
          // Get sections to show/hide
          const uploadSection = document.getElementById('uploadSection');
          const modelLibrarySection = document.getElementById('modelLibrarySection');
          
          if (!uploadSection || !modelLibrarySection) {
            console.error('Could not find required sections');
            return;
          }
          
          if (source === 'upload') {
            uploadSection.style.display = 'block';
            modelLibrarySection.style.display = 'none';
          } else if (source === 'library') {
            uploadSection.style.display = 'none';
            modelLibrarySection.style.display = 'block';
            
            // Load models if not already loaded
            if (currentModels.length === 0 && !isLoading) {
              loadModelPage(1);
            }
          }
        }, { capture: true });
      });
    }
  }
  
  // Create a model card element
  function createModelCard(model) {
    const card = document.createElement('div');
    card.className = 'model-card';
    card.setAttribute('data-model-id', model.id);
    
    // Use provided image URL or default
    const imageUrl = model.imageUrl || 'https://cdn.thingiverse.com/assets/default/models/placeholder.jpg';
    
    card.innerHTML = `
      <div class="model-preview">
        <img src="${imageUrl}" alt="${model.name}">
      </div>
      <div class="model-info">
        <h4 class="model-name">${model.name}</h4>
      </div>
      <button class="select-model-btn">Use This Model</button>
    `;
    
    // Add direct event listener for select button
    const selectBtn = card.querySelector('.select-model-btn');
    if (selectBtn) {
      selectBtn.addEventListener('click', function() {
        selectModel(model.id);
      });
    }
    
    return card;
  }
  
  // Display models for the current page
  function displayModels() {
    const modelGrid = document.getElementById('modelGrid');
    if (!modelGrid) {
      console.error('modelGrid element not found in displayModels');
      return;
    }
    
    // Apply grid styling optimized for 15 items (3x5 or 5x3 grid layout)
    modelGrid.style.display = 'grid';
    modelGrid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(160px, 1fr))';
    modelGrid.style.gap = '16px';
    modelGrid.style.padding = '10px';
    
    // Clear current grid
    modelGrid.innerHTML = '';
    
    // Show empty state if no models
    if (currentModels.length === 0) {
      const emptyState = document.createElement('div');
      emptyState.className = 'empty-state';
      emptyState.style.gridColumn = '1 / -1';
      emptyState.style.textAlign = 'center';
      emptyState.style.padding = '30px';
      emptyState.innerHTML = `
        <p style="font-size: 16px; color: #636e72;">No models found matching your criteria</p>
        <button id="resetFiltersBtn" style="padding: 10px 20px; background: linear-gradient(135deg, #0984e3, #2980b9); color: white; border: none; border-radius: 25px; margin-top: 15px; cursor: pointer; font-weight: 500;">Reset Search</button>
      `;
      modelGrid.appendChild(emptyState);
      
      // Add event listener to reset button
      const resetBtn = document.getElementById('resetFiltersBtn');
      if (resetBtn) {
        resetBtn.addEventListener('click', function() {
          const searchInput = document.getElementById('modelSearchInput');
          
          if (searchInput) searchInput.value = '';
          
          currentSearchTerm = '';
          loadModelPage(1);
        });
      }
      return;
    }
    
    // Add model cards
    currentModels.forEach(model => {
      const card = createModelCard(model);
      modelGrid.appendChild(card);
    });
  }
  
  // Update pagination controls
  function updatePaginationControls(hasMorePages) {
    const paginationInfo = document.querySelector('.pagination-info');
    const paginationPrev = document.querySelector('.pagination-prev');
    const paginationNext = document.querySelector('.pagination-next');
    
    if (paginationInfo) {
      paginationInfo.textContent = `Page ${currentPage}`;
    }
    
    if (paginationPrev) {
      paginationPrev.disabled = currentPage <= 1 || isLoading;
    }
    
    if (paginationNext) {
      // Force enable the next button - we'll always allow going to next page
      paginationNext.disabled = false;
    }
    
    console.log('Pagination updated:', {
      currentPage: currentPage,
      hasMorePages: hasMorePages,
      isLoading: isLoading,
      prevDisabled: paginationPrev ? paginationPrev.disabled : 'unknown',
      nextDisabled: paginationNext ? paginationNext.disabled : 'unknown'
    });
  }
  
  // Function to select a model
  function selectModel(modelId) {
    console.log('Model selected:', modelId);
    
    const model = currentModels.find(m => m.id === modelId);
    if (!model) {
      console.error('Model not found:', modelId);
      return;
    }
    
    // Show active loading state
    const loadingOverlay = document.getElementById('loading');
    if (loadingOverlay) {
      loadingOverlay.classList.add('active');
      const loadingText = loadingOverlay.querySelector('.loading-text');
      if (loadingText) {
        loadingText.textContent = `Loading model: ${model.name}...`;
      }
    }
    
    // Update model name in the UI
    const modelNameEl = document.getElementById('model-name');
    if (modelNameEl) {
      modelNameEl.textContent = model.name;
    }
    
    // Update model properties form field
    const modelProp = document.getElementById('model-prop');
    if (modelProp) {
      modelProp.value = model.name;
    }
    
    // Dispatch an event with the selected model
    const event = new CustomEvent('modelSelected', {
      detail: model
    });
    
    document.dispatchEvent(event);
    
    // Show confirmation to the user
    const confirmationToast = document.createElement('div');
    confirmationToast.className = 'confirmation-toast';
    confirmationToast.style.position = 'fixed';
    confirmationToast.style.bottom = '20px';
    confirmationToast.style.right = '20px';
    confirmationToast.style.backgroundColor = '#4CAF50';
    confirmationToast.style.color = 'white';
    confirmationToast.style.padding = '15px 20px';
    confirmationToast.style.borderRadius = '4px';
    confirmationToast.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
    confirmationToast.style.zIndex = '1000';
    confirmationToast.style.transition = 'opacity 0.3s ease';
    
    confirmationToast.innerHTML = `
      <div style="display: flex; align-items: center;">
        <div style="margin-right: 10px;">✓</div>
        <div>
          <strong style="display: block; margin-bottom: 3px;">${model.name}</strong>
          <span>has been selected</span>
        </div>
      </div>
    `;
    
    document.body.appendChild(confirmationToast);
    
    // Automatically remove the toast after a few seconds
    setTimeout(() => {
      confirmationToast.style.opacity = '0';
      setTimeout(() => {
        confirmationToast.remove();
      }, 300);
    }, 3000);
    
    // Keep user on the current tab (don't switch to upload tab)
    /* Removed automatic tab switching:
    const uploadTab = document.querySelector('.source-tab[data-source="upload"]');
    if (uploadTab) {
      uploadTab.click();
    }
    */
  }
  
  // Run initialization
  initialize();
});